import PropTypes from 'prop-types'
import { numberToCurrency } from 'lib/money'
import { RangeSlider } from 'components/forms'
import { FilterSection } from './filter-section'
import { SECTIONS } from '../../helpers'

export const PriceFilterSection = ({
  open,
  minPrice,
  maxPrice,
  productCount,
  setMinPrice,
  setMaxPrice,
  priceRange,
}) => {
  const [minOption, maxOption] = priceRange
  const optionDiff = maxOption - minOption
  const disabled = optionDiff < 1

  const handleChange = ([newMin, newMax]) => {
    if (newMin !== minPrice) {
      setMinPrice(newMin)
    }
    if (newMax !== maxPrice) {
      setMaxPrice(newMax)
    }
  }

  return (
    <FilterSection
      disabled={disabled}
      title={`${SECTIONS.PRICE_RANGE} (${productCount})`}
      open={open}
      collapsedContent={
        maxPrice && minPrice
          ? `${numberToCurrency(minPrice)} - ${numberToCurrency(maxPrice)}`
          : undefined
      }
    >
      {!disabled && (
        <div className="mal mtxl ptm">
          <RangeSlider
            labelPrefix="$"
            onChange={handleChange}
            step={optionDiff < 20 ? 1 : 10}
            maxValue={Math.ceil(maxPrice)}
            minValue={Math.floor(minPrice)}
            maxOption={Math.ceil(maxOption)}
            minOption={Math.floor(minOption)}
          />
        </div>
      )}
    </FilterSection>
  )
}

PriceFilterSection.propTypes = {
  minPrice: PropTypes.number,
  maxPrice: PropTypes.number,
  open: PropTypes.bool.isRequired,
  productCount: PropTypes.number.isRequired,
  setMinPrice: PropTypes.func.isRequired,
  setMaxPrice: PropTypes.func.isRequired,
  priceRange: PropTypes.arrayOf(PropTypes.number).isRequired,
}

PriceFilterSection.defaultProps = {
  minPrice: undefined,
  maxPrice: undefined,
}
